// extracted by mini-css-extract-plugin
module.exports = {"bar":"audio-bar_bar__d5ii0","progress":"audio-bar_progress__2qH4k"};